// src/utils/tokenConfig.js

export const TOKEN_MAP = {
  1: { // Ethereum Mainnet
    usdt: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    usdc: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    dai:  '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    wbtc: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    shib: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE',
    pepe: '0x6982508145454Ce325dDbE47a25d4ec3d2311933'
  },
  56: { // BSC
    usdt: '0x55d398326f99059fF775485246999027B3197955',
    usdc: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    dai:  '0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3',
    busd: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56', // King of BSC
    cake: '0x0E09Fabb73Bd3Ade0a17ECC321fD13a19e81cE82'
  },
  137: { // Polygon
    usdt: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    usdc: '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
    dai:  '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063',
    weth: '0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619' // WETH di Polygon mahal
  },
  42161: { // Arbitrum
    usdt: '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',
    usdc: '0xaf88d065e77c8cC2239327C5EDb3A432268e5831',
    arb:  '0x912CE59144191C1204E64559FE8253a0e49E6548'
  },
  8453: { // Base
    usdc: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
    brett: '0x532f27101965dd16442E59d40670FaF5eBB142E4' // Base Meme king
  },
  43114: { // Avalanche
    usdt: '0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7',
    usdc: '0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E'
  }
};

// Estimasi Harga untuk Kalkulasi Prioritas ($)
export const PRICE_ESTIMATES = {
  1: 2600,      // ETH
  56: 600,      // BNB
  137: 0.40,    // MATIC
  43114: 35,    // AVAX
  8453: 2600,   // ETH (Base)
  42161: 2600,  // ETH (Arb)
  10: 2600,     // ETH (Op)
  
  // Tokens (Hardcoded estimate biar cepat)
  DEFAULT: 1,   // Stablecoin $1
  WBTC: 62000,
  WETH: 2600,
  SHIB: 0.00001,
  PEPE: 0.00001,
  CAKE: 2,
  ARB: 0.5,
  BRETT: 0.1
};